<template lang='pug'>
  div.sc-predictiveModelsSports
    ods-row.h100(type='flex' justify='center')
      ods-col.sc-predictiveModelsSports__filter(
        :xs='4'
        :sm='4'
        :md='4'
      )
        p.title {{ $t('predictiveModels.sportcenters') }}
        ods-select(
          v-model="searchValue"
          :placeholder="$t('predictiveModels.search')"
          @change="handleFiltrable"
          :filterable="true")
          ods-option(
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value")
        ods-accordion(
          v-model="activeNames"
          :accordion="accordion")
          ods-accordion-item(
            v-for="item in accordionItems"
            :key="item.name"
            :name="item.name"
            :title="$t(item.title)")
              ods-radio-group(v-model="item.select")
                ods-radio(
                  v-for="option in item.list"
                  :label="option"
                  :key='option'
                  @change="handleChange"
                  ) {{ option }}
      ods-col.sc-predictiveModelsSports__content(
        :xs='20'
        :sm='20'
        :md='20'
      )
        div.card
          div.card__content(v-if="noData")
            div.noData
              img(src="@/assets/images/generic/noSportsCenter.png")
              p Selecciona un Centro Deportivo del panel izquierdo
          div(v-else)
            ods-tabs(v-model="activeTab" @tab-click="handleChangeTab")
              ods-tab-pane(
                v-loading="loading"
                v-for="item in tabs"
                :key="item.name"
                :label="$t(item.title)"
                :name="item.name")
                div.card__content.box
                  div.d-flex.section-main
                    div.section-main__left
                      div.d-flex.actual
                        p {{ $t('predictiveModels.occupationinfacilitiesof') }} {{ $t(item.title) | lowercase }}
                        div
                          p.actualPrice {{ $t('predictiveModels.actualprice') }}
                          p.price {{ item.price }}
                            span €
                    div.section-main__right
                      div.d-flex.predictive
                        div.predictive__left
                          p {{ $t('predictiveModels.newprice') }}
                          ods-slider(
                              v-model='item.priceValue'
                              :min='0'
                              :max='30'
                              :show-tooltip='showTooltip'
                              :debounce='debounceData'
                              :step='1'
                              @change='handleChangeSlider')
                        div.predictive__right
                          span.predictive__price {{ item.priceValue }}
                            span €
                          // p.predictive__percentaje 0%
                  div.boxCanvas
                    canvas(:id="item.name")
</template>
<script>

import mapElements from '@/mixins/mapElements'
import ChartJS from 'chart.js'

export default {
  name: 'PredictiveModelsSports',
  data () {
    return {
      searchValue: '',
      arrayDataPrediction: [],
      arrayDataHistory: [],
      options: [],
      loading: false,
      showTooltip: true,
      debounceData: 300,
      activeTab: 'TENIS',
      noData: true,
      SelectedSportCenter: null,
      searchText: '',
      activeNames: ['1'],
      accordion: false,
      tabs: [
        {
          'title': 'predictiveModels.paddel',
          'name': 'PADEL',
          'price': 10,
          'priceValue': 10,
          'chart': null
        },
        {
          'title': 'predictiveModels.tennis',
          'name': 'TENIS',
          'price': 9,
          'priceValue': 9,
          'chart': null
        },
        {
          'title': 'predictiveModels.soccer',
          'name': 'FUTBOL',
          'price': 7,
          'priceValue': 7,
          'chart': null
        }
      ],
      accordionItems: [
        {
          'name': 1,
          'title': 'predictiveModels.southzone',
          'list': ['zona sur 1', 'zona sur 2', 'zona sur 3', 'zona sur 4']
        },
        {
          'name': 2,
          'title': 'predictiveModels.northzone',
          'list': ['zona norte 1', 'zona norte 2', 'zona norte 3', 'zona norte 4'],
          'select': null
        },
        {
          'name': 3,
          'title': 'predictiveModels.center',
          'list': ['centro 1', 'centro 2', 'centro 3', 'centro 4'],
          'select': null
        }
      ]
    }
  },
  mixins: [ mapElements ],
  computed: {
    getLangData () {
      return this.$store.getters.getLang
    }
  },
  watch: {
    getLangData () {
      this.initLineChart()
    }
  },
  filters: {
    lowercase: function (value) {
      if (!value) return ''
      value = value.toString()
      let m = value.toLowerCase()
      return m
    }
  },
  components: {
  },
  methods: {
    handleChangeSlider (value) {
      const vm = this
      this.tabs.forEach(item => {
        if (vm.activeTab === item.name) {
          if (item.price > value) {
            let ap = vm.getArrayDataPredictive(60, 90)
            let aux = []
            for (var x = 0; x < 13; x++) {
              if (x < 7) {
                aux[x] = vm.arrayDataPrediction[x]
              } else {
                aux[x] = ap[x]
              }
            }
            vm.arrayDataPrediction = aux
          } else {
            let ap = vm.getArrayDataPredictive(30, 50)
            let aux = []
            for (var y = 0; y < 13; y++) {
              if (y < 7) {
                aux[y] = vm.arrayDataPrediction[y]
              } else {
                aux[y] = ap[y]
              }
            }
            vm.arrayDataPrediction = aux
          }
          item.chart.data.datasets[2] = {
            label: vm.$t('predictiveModels.prediction'),
            fill: true,
            backgroundColor: 'transparent',
            borderColor: '#3982D0',
            borderDash: [2, 4],
            pointRadius: 0,
            tension: 0,
            data: vm.arrayDataPrediction
          }
          item.chart.update()
        }
      })
    },
    labelGraphMonth () {
      let months = {
        English: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        Spanish: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
      }
      let aux = []
      let elem = new Date()
      elem.setHours(0)
      elem.setMinutes(0)
      let newDay = new Date()
      newDay.setMonth((elem.getMonth() - 7))
      for (var i = 0; i < 13; i++) {
        newDay.setMonth((newDay.getMonth() + 1))
        aux.push('' + months[this.$i18n.locale][newDay.getMonth()])
      }
      // despues hacer un for sumando meses y listo
      return aux
    },
    initLineChart () {
      const vm = this
      this.arrayDataPrediction = this.getArrayDataPredictive(50, 75)
      this.arrayDataHistory = this.getArrayDataHistory(50, 75)
      this.arrayDataPrediction[6] = this.arrayDataHistory[6]
      const data = {
        labels: vm.labelGraphMonth(),
        datasets: [
          {
            label: vm.$t('predictiveModels.historical'),
            fill: false,
            backgroundColor: '#3982D0',
            borderColor: '#3982D0',
            pointRadius: 0,
            tension: 0,
            data: vm.arrayDataHistory
          }, {
            label: 'MAX',
            fill: false,
            backgroundColor: '#FFA800',
            borderColor: '#FFA800',
            pointRadius: 0,
            tension: 0,
            data: Array.from({length: 13}, () => 100)
          }, {
            label: vm.$t('predictiveModels.prediction'),
            fill: true,
            backgroundColor: 'transparent',
            borderColor: '#3982D0',
            borderDash: [2, 4],
            pointRadius: 0,
            tension: 0,
            data: vm.arrayDataPrediction
          }
        ]
      }
      let ctx = document.getElementById(this.activeTab).getContext('2d')
      let chart = this.tabs.filter(elem => elem.name === vm.activeTab)
      if (chart[0].chart === null) {
        chart[0].chart = new ChartJS(ctx, {
          type: 'line',
          lineAtIndex: [6],
          data: data,
          plugins: [{
            beforeInit: function (chart, options) {
              chart.legend.afterFit = function () {
                this.height = this.height + 25
              }
            }
          }],
          options: {
            responsive: true,
            legend: {
              align: 'start',
              labels: {
                boxWidth: 14,
                padding: 18,
                filter: function (item, chart) {
                  // Elimina el legend que coincida con lo indicado
                  return !item.text.includes('Future')
                }
              }
            },
            scales: {
              xAxes: [{
                gridLines: {
                  display: false,
                  drawBorder: false
                },
                ticks: {
                  padding: 10,
                  fontSize: 9,
                  autoSkip: false,
                  maxRotation: 0,
                  minRotation: 0
                }
              }],
              yAxes: [{
                gridLines: {
                  drawTicks: false
                },
                ticks: {
                  padding: 9,
                  fontSize: 9,
                  max: 125,
                  min: 0,
                  stepSize: 25
                },
                scaleLabel: {
                  display: true,
                  labelString: this.$t('predictiveModels.occupationPercentage'),
                  fontSize: 11
                }
              }]
            }
          }
        })
        vm.printVerticalLine()
      } else {
        let datasets = [
          {
            label: this.$t('predictiveModels.historical'),
            fill: false,
            backgroundColor: '#3982D0',
            borderColor: '#3982D0',
            pointRadius: 0,
            tension: 0,
            data: this.arrayDataHistory
          }, {
            label: 'MAX',
            fill: false,
            backgroundColor: '#FFA800',
            borderColor: '#FFA800',
            pointRadius: 0,
            tension: 0,
            data: Array.from({length: 13}, () => 100)
          }, {
            label: this.$t('predictiveModels.prediction'),
            fill: true,
            backgroundColor: 'transparent',
            borderColor: '#3982D0',
            borderDash: [2, 4],
            pointRadius: 0,
            tension: 0,
            data: this.arrayDataPrediction
          }
        ]
        chart[0].chart.data.datasets = datasets
        chart[0].chart.update()
      }
    },
    handleChange (value) {
      this.noData = false
      this.loading = true
      this.searchValue = value
      this.accordionItems.forEach(item => {
        let encontrado = false
        item.list.forEach(elem => {
          if (elem === value) {
            encontrado = true
          }
        })
        if (!encontrado) {
          item.select = null
        }
      })
      setTimeout(() => {
        this.loading = false
        this.initLineChart()
      }, 500)
    },
    handleChangeTab () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.initLineChart()
      }, 500)
    },
    handleFiltrable (value) {
      this.noData = false
      this.loading = true
      this.accordionItems.forEach(item => {
        let encontrado = false
        item.list.forEach(elem => {
          if (elem === value) {
            encontrado = true
            item.select = value
          }
        })
        if (!encontrado) {
          item.select = null
        }
      })
      setTimeout(() => {
        this.loading = false
        this.initLineChart()
      }, 500)
    },
    getArrayDataPredictive (min, max) {
      let arrayData = []
      for (var i = 0; i < 13; i++) {
        arrayData.push(Math.floor(Math.random() * (max - min) + min))
      }
      return arrayData
    },
    getArrayDataHistory (min, max) {
      let arrayData = []
      for (var i = 0; i < 7; i++) {
        arrayData.push(Math.floor(Math.random() * (max - min) + min))
      }
      return arrayData
    },
    printVerticalLine () {
      const verticalLinePlugin = {
        getLinePosition: function (chart, pointIndex) {
          const meta = chart.getDatasetMeta(0) // first dataset is used to discover X coordinate of a point
          const data = meta.data
          return data[pointIndex]._model.x
        },
        renderVerticalLine: function (chartInstance, pointIndex) {
          const lineLeftOffset = this.getLinePosition(chartInstance, pointIndex)
          const scale = chartInstance.scales['y-axis-0']
          const context = chartInstance.chart.ctx

          // render vertical line
          context.beginPath()
          context.strokeStyle = '#000000'
          context.moveTo(lineLeftOffset, scale.top)
          context.lineTo(lineLeftOffset, scale.bottom)
          context.stroke()

          // write label
          // // context.fillStyle = '#000000'
          // // context.textAlign = 'center'
          // // context.fillText('MES ACTUAL', lineLeftOffset, (scale.bottom - scale.top) / 2 + scale.top)
        },

        afterDatasetsDraw: function (chart, easing) {
          if (chart.config.lineAtIndex) {
            chart.config.lineAtIndex.forEach(pointIndex => this.renderVerticalLine(chart, pointIndex))
          }
        }
      }
      ChartJS.plugins.register(verticalLinePlugin)
    }
  },
  created () {
    const vm = this
    this.accordionItems.forEach(elem => {
      elem.list.forEach(option => {
        vm.options.push({
          value: option,
          label: option
        })
      })
    })
  }
}
</script>
<style lang='scss' scoped>
  /deep/ .ods-input {
    &__suffix {
      display: none;
    }
  }
  .sc-predictiveModelsSports{
    .predictive{
      padding: 12px 24px;
      background: #F9F9FB;
      &__left{
        flex: 7 0 0;
        & > p {
          font-size: 9px;
          line-height: 16px;
          text-transform: uppercase;
          color: #6E767D;
          margin: 0 0 30px;
        }
      }
      &__right{
        flex: 1 0 0;
        text-align: right;
      }
      &__price{
        font-size: 36px;
        font-weight: 500;
        line-height: 56px;
        color: #060E14;
        margin: 0 0 0 30px;
        & > span {
          font-size: 18px;
          margin: 0 0 0 10px;
        }
      }
      &__percentaje{
        font-size: 12px;
        line-height: 20px;
        color: #6E767D;
      }

    }
    .section{
      &-main{
        .actual{
          justify-content: space-between;
          padding: 12px 0 12px 12px;
          & > p {
            font-size: 16px;
            line-height: 24px;
            font-weight: 500;
            color: #060E14;
          }
          .actualPrice{
            font-size: 9px;
            line-height: 16px;
            text-transform: uppercase;
            color: #6E767D;
          }
          .price{
            font-weight: 500;
            font-size: 18px;
            line-height: 32px;
            color: #060E14;
          }
        }
        &__left, &__right {
          flex: 1 0 0;
          padding: 24px;
        }
      }
    }
    .ods-radio-group{
      label {
        display: block;
        margin-top: 7px;
        line-height: 1;
      }
    }
    .h100 {
      height: calc(100vh - 64px);
    }
    /deep/ .ods-tabs__header{
      margin: 15px 0 0 18px;
    }
    &__filter {
      padding: 18px;
      background: white;
      .title{
      font-size: 12px;
      line-height: 20px;
      font-weight: 500;
      margin: 0 0 6px;
      /* identical to box height, or 167% */
      }
    }
    &__content {
      .card{
        height: calc(100% - 18px);
        &__content{
          height: calc(100% - 18px);
          margin: 18px;
          background: white;
          // height: calc(100vh - 100px);
          &.box{
            margin: 0 18px 18px;
            // height: calc(100vh - 130px);
            .boxCanvas{
              height: calc(100vh - 140px);
              padding: 0 24px;
            }
          }
          .noData {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            p{
              max-width: 158px;
              text-align: center;
              line-height: 1.4;
              color: #6E767D;
            }
          }
        }
      }
    }
    .d-flex {
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/predictiveModels/PredictiveModelsSports.vue